import { useLocation } from "react-router-dom";
import AccountLayout from "../../components/AccountLayout.component";
import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material/";
import { VisibilityOff, RemoveRedEye } from "@mui/icons-material/";
import Footer from "../../components/Footer.component";
import AccountFooter from "./AccountFooter";

function ChangePassword() {
  const [old_password, setOldPassword] = useState("");
  const [new_password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showOldTextPassword, setShowOldTextPassword] = useState(false);
  const [textOldPasswordType, setTextOldPasswordType] = useState("password");
  const [showNewTextPassword, setShowNewTextPassword] = useState(false);
  const [textNewPasswordType, setTextNewPasswordType] = useState("password");
  const [showConfirmTextPassword, setShowConfirmTextPassword] = useState(false);
  const [textConfirmPasswordType, setTextConfirmPasswordType] =
    useState("password");
  const { pathname } = useLocation();
  const pathArr = pathname?.split("/");
  const lastIndex = pathArr[pathArr.length - 1];
  const title = `${lastIndex[0].toUpperCase()}${lastIndex
    .slice(1)
    .replace("-", " ")}`;

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `https://staging.drugstoc.com/api/v2/auth/change_password`,
        {
          old_password,
          new_password,
        }
      );

      if (response.status === 200) {
        setMessage("Password changed successfully!");
      }
    } catch (error) {
      setMessage("Error changing password. Please try again.");
    }
  };

  const showOldPassword = () => {
    let type: any;
    if (showOldTextPassword === false) {
      setShowOldTextPassword(true);
      setTextOldPasswordType("text");
    } else {
      setShowOldTextPassword(false);
      setTextOldPasswordType("password");
    }
    return type;
  };

  const showNewPassword = () => {
    let type: any;
    if (showNewTextPassword === false) {
      setShowNewTextPassword(true);
      setTextNewPasswordType("text");
    } else {
      setShowNewTextPassword(false);
      setTextNewPasswordType("password");
    }
    return type;
  };

  const showConfirmPassword = () => {
    let type: any;
    if (showConfirmTextPassword === false) {
      setShowConfirmTextPassword(true);
      setTextConfirmPasswordType("text");
    } else {
      setShowConfirmTextPassword(false);
      setTextConfirmPasswordType("password");
    }
    return type;
  };

  useEffect(() => {
    document.title = `${title} | DrugStoc`;
  }, [title]);

  return (
    <>
      <AccountLayout>
        <>
          <h2 style={{ color: "##1C1B1F" }}>Change Password</h2>
          <p style={{ color: "#787579" }}>
            Let's get you started with DrugStoc
          </p>
          <form
            onSubmit={handleSubmit}
            style={{
              border: "1px solid #c9c5ca",
              borderRadius: 8,
              paddingBottom: 40,
              marginBottom: 200,
            }}
          >
            <div style={{ paddingLeft: 16, borderBottom: "1px solid #c9c5ca" }}>
              <h3 style={{ color: "##1C1B1F" }}>Password Reset</h3>
            </div>
            <div style={{ paddingLeft: 16 }}>
              <h3 style={{ color: "##1C1B1F" }}>
                <label
                  htmlFor="old_password"
                  style={{ position: "relative", top: 10 }}
                >
                  Old Password*
                </label>
              </h3>
              <Box sx={{ position: "relative" }}>
                <input
                  className="inputNewPassword"
                  type={textOldPasswordType}
                  id="old_password"
                  value={old_password}
                  onChange={(e) => setOldPassword(e.target.value)}
                  style={{
                    border: "1px solid #C9C5CA",
                    borderRadius: 8,
                    height: 45,
                    width: "calc(100% - 16px)",
                    textIndent: 10,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    right: 40,
                    top: 10,
                    color: "#8692a6",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                  onClick={showOldPassword}
                >
                  {showOldTextPassword ? <RemoveRedEye /> : <VisibilityOff />}
                </div>
              </Box>
            </div>
            <div style={{ paddingLeft: 16 }}>
              <h3 style={{ color: "##1C1B1F" }}>
                <label
                  htmlFor="new_password"
                  style={{ position: "relative", top: 10 }}
                >
                  New Password*
                </label>
              </h3>
              <Box sx={{ position: "relative" }}>
                <input
                  className="inputConfirmPassword"
                  type={textNewPasswordType}
                  id="new_password"
                  value={new_password}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{
                    border: "1px solid #C9C5CA",
                    borderRadius: 8,
                    height: 45,
                    width: "calc(100% - 16px)",
                    textIndent: 10,
                  }}
                />
                <p
                  style={{
                    position: "absolute",
                    right: 40,
                    top: 0,
                    color: "#8692a6",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                  onClick={showNewPassword}
                >
                  {showNewTextPassword ? <RemoveRedEye /> : <VisibilityOff />}
                </p>
              </Box>
              <h3 style={{ color: "##1C1B1F" }}>
                <label
                  htmlFor="confirmPassword"
                  style={{ position: "relative", top: 10 }}
                >
                  Confirm Password*
                </label>
              </h3>
              <Box sx={{ position: "relative" }}>
                <input
                  className="inputConfirmPassword"
                  type={textConfirmPasswordType}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{
                    border: "1px solid #C9C5CA",
                    borderRadius: 8,
                    height: 45,
                    width: "calc(100% - 16px)",
                    textIndent: 10,
                  }}
                />
                <p
                  style={{
                    position: "absolute",
                    right: 40,
                    top: 0,
                    color: "#8692a6",
                    fontWeight: 500,
                    textTransform: "uppercase",
                    fontSize: 14,
                    cursor: "pointer",
                  }}
                  onClick={showConfirmPassword}
                >
                  {showConfirmTextPassword ? (
                    <RemoveRedEye />
                  ) : (
                    <VisibilityOff />
                  )}
                </p>
              </Box>
              <Button
                variant="contained"
                type="submit"
                sx={{ mt: 5, mx: "auto", width: "calc(100% - 16px)" }}
                disabled={
                  old_password.length > 0 &&
                  new_password !== "" &&
                  new_password === confirmPassword
                    ? false
                    : true
                }
              >
                Save
              </Button>

              {message && (
                <p
                  style={{
                    color:
                      message === "Error changing password. Please try again."
                        ? "red"
                        : "green",
                  }}
                >
                  {message}
                </p>
              )}
            </div>
          </form>
        </>
      </AccountLayout>
      <AccountFooter />
    </>
  );
}

export default ChangePassword;
